import { createFeature, createReducer, on, provideState } from '@ngrx/store';
import { WindowMessagesActions } from './window-messages.actions';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { WindowMessagesEffects } from './window-messages.effects';
import { WindowStateActions } from '../window/window.actions';

export const initialState: Readonly<WindowMessageData> = {
  context: '',
  urlParams: {},
};

export const windowMessagesFeature = createFeature({
  name: 'windowMessages',
  reducer: createReducer(
    initialState,
    on(WindowMessagesActions.initializeApp, (state, { urlParams }) => {
      return { ...state, urlParams };
    }),
    on(WindowStateActions.requestToOpenWindow, (state, { context }) => {
      return { ...state, context };
    })
  ),
});

export const { selectContext, selectUrlParams } = windowMessagesFeature;

export function provideWindowMessagesFeature() {
  return makeEnvironmentProviders([
    provideState(windowMessagesFeature),
    provideEffects(WindowMessagesEffects),
  ]);
}
